import { LtdOutComeService } from '../../Services/LtdOutComeConstant.service';

export const outComeTranslation = (label: string) => {
    return LtdOutComeService.resolveLtdField(label);
};
